import { render, staticRenderFns } from "./VisualizacionSeguidoresArtistas.vue?vue&type=template&id=37bc90ab&scoped=true&"
import script from "./VisualizacionSeguidoresArtistas.vue?vue&type=script&lang=js&"
export * from "./VisualizacionSeguidoresArtistas.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacionSeguidoresArtistas.vue?vue&type=style&index=0&id=37bc90ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc90ab",
  null
  
)

export default component.exports